/**
 * Axis ticks on 1, 2, 2.5 or 5 × a power of ten (recharts' own can land on steps like 55), whole
 * numbers only, covering every value and zero.
 */
export function niceTicks(values: number[]): number[] {
  const lo = Math.min(0, ...values)
  const hi = Math.max(0, ...values)
  if (hi === lo) return [0, 1]
  const rough = (hi - lo) / 5
  const power = 10 ** Math.floor(Math.log10(rough))
  const step =
    [1, 2, 2.5, 5, 10].map((m) => m * power).find((s) => s >= rough && Number.isInteger(s)) ??
    Math.ceil(rough)
  const ticks: number[] = []
  for (let t = Math.floor(lo / step) * step; t < hi + step; t += step) {
    ticks.push(t)
    if (t >= hi) break
  }
  return ticks
}
